<template>
  <div class="popup-ivi">
    <h1 class="a11y-hidden">wavve</h1>
    <div class="popup-ivi-txt">
      <IconCar />
      <h2>인증 완료</h2>
      <p>
        인증이 완료되었습니다. <br />
        차량에서 Wavve를 즐겨주세요. <br />
        확인 버튼을 누르시면 홈으로 이동합니다.
      </p>
    </div>
    <div class="popup-ivi-btn">
      <button type="button" @click="confirm">확인</button>
    </div>
  </div>
</template>
<script>
import IconCar from '@/assets/svg/common/ico_car.svg'

export default {
  name: 'ExternalVerifiedAdultConfirm',
  components: {
    IconCar
  },
  methods: {
    confirm () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" src=@/assets/scss/ivi/ivi.scss></style>
